<app-navbar-style-three></app-navbar-style-three>

<ng-container *ngIf="foundnews != null">
  <!-- Hero Section with Award Badge -->
  <section class="achievement-detail-hero">
    <div class="hero-background">
      <div class="hero-pattern"></div>
      <div class="hero-gradient"></div>
    </div>
    
    <div class="container">
      <div class="achievement-detail-hero__content">
        <a routerLink="/achievements" class="breadcrumb-link">
          <svg class="breadcrumb-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Back to Achievements
        </a>
        
        <div class="hero-badge">
          <svg class="hero-badge__icon" width="32" height="32" viewBox="0 0 24 24" fill="none">
            <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="currentColor"/>
          </svg>
          <span class="hero-badge__label">Achievement</span>
        </div>
        
        <h1 class="achievement-detail-hero__title">{{ foundnews.TitleEn }}</h1>
      </div>
    </div>
  </section>

  <!-- Main Content -->
  <article class="achievement-detail-article">
    <div class="container">
      <div class="achievement-detail-content">
        <!-- Featured Image with Overlay -->
        <div class="featured-section" *ngIf="foundnews.ShowAttachments && foundnews.ShowAttachments.length > 0">
          <div class="featured-image">
            <img 
              [src]="foundnews.ShowAttachments[0].FilePath" 
              [alt]="foundnews.TitleEn"
              class="featured-image__img"
            />
            <div class="featured-image__overlay">
              <div class="featured-image__decoration"></div>
            </div>
          </div>
        </div>

        <!-- Article Body -->
        <div class="article-wrapper">
          <div class="article-body" [innerHTML]="foundnews.DetailsEn"></div>
        </div>

        <!-- Image Gallery -->
        <div class="image-gallery" *ngIf="foundnews.ShowAttachments && foundnews.ShowAttachments.length > 1">
          <div class="gallery-header">
            <h3 class="gallery-header__title">Gallery</h3>
            <div class="gallery-header__line"></div>
          </div>
          
          <div class="image-gallery__grid">
            <a 
              *ngFor="let image of foundnews.ShowAttachments; let i = index"
              [href]="image.FilePath"
              [title]="foundnews.TitleEn + ' - Image ' + (i + 1)"
              class="gallery-item"
              target="_blank"
              rel="noopener noreferrer"
              [attr.data-index]="i"
            >
              <div class="gallery-item__wrapper">
                <img 
                  [src]="image.FilePath" 
                  [alt]="foundnews.TitleEn + ' - Image ' + (i + 1)"
                  class="gallery-item__img"
                  loading="lazy"
                />
                <div class="gallery-item__overlay">
                  <div class="gallery-item__icon">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                      <path d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M10 7V13M7 10H13" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="gallery-item__number">{{ i + 1 }}</div>
            </a>
          </div>
        </div>

        <!-- Action Footer -->
        <div class="article-footer">
          <div class="footer-actions">
            <a routerLink="/achievements" class="btn-primary">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              View All Achievements
            </a>
            <button class="btn-secondary" onclick="window.print()">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M6 9V2H18V9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M6 18H4C3.46957 18 2.96086 17.7893 2.58579 17.4142C2.21071 17.0391 2 16.5304 2 16V11C2 10.4696 2.21071 9.96086 2.58579 9.58579C2.96086 9.21071 3.46957 9 4 9H20C20.5304 9 21.0391 9.21071 21.4142 9.58579C21.7893 9.96086 22 10.4696 22 11V16C22 16.5304 21.7893 17.0391 21.4142 17.4142C21.0391 17.7893 20.5304 18 20 18H18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M18 14H6V22H18V14Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Print
            </button>
          </div>
        </div>
      </div>
    </div>
  </article>
</ng-container>

<!-- Loading/Error State -->
<div class="empty-state" *ngIf="foundnews == null">
  <div class="container">
    <div class="empty-state__content">
      <svg class="empty-state__icon" width="100" height="100" viewBox="0 0 24 24" fill="none">
        <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <h2 class="empty-state__title">Achievement Not Found</h2>
      <p class="empty-state__text">The achievement you're looking for doesn't exist or has been removed.</p>
      <a routerLink="/achievements" class="btn-primary">
        Return to Achievements
      </a>
    </div>
  </div>
</div>